<template>
  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2668.461487304373!2d14.080972515429126!3d48.02411297921448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4773e8b2e7f92899%3A0x36d155f4ed2f6256!2sSportstra%C3%9Fe+30%2C+4551+Ried+im+Traunkreis!5e0!3m2!1sde!2sat!4v1487951599770" width="100%" height="600" frameborder="0" style="border:0" allowfullscreen></iframe> 
</template>

<script>
export default {
  props: ['blok'],
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Maps.vue